import React, { Fragment } from 'react';
import { List } from 'immutable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SelectCityModal from './SelectCityModal';

class SelectCity extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      openedModal: false
    };

    this.onClickModalControl = this.onClickModalControl.bind(this);
  }


  onClickModalControl () {
    this.setState({
      openedModal: true
    });
  }

  renderModalControl () {
    const { regionNameRu } = this.props;
    return (
      <div className='btn-pill' onClick={this.onClickModalControl}>
        <span className="icon icon-map-marker-new"></span>
        <span>{regionNameRu ? regionNameRu : 'Поменять город'}</span>
      </div>
    );
  }

  renderModal () {
    const { openedModal } = this.state;
    const { domains } = this.props;
    return (
      <SelectCityModal
        visible={openedModal}
        domains={domains}
        onClose={() => this.setState({openedModal: false})}
      />
    );
  }

  render () {
    return (
      <Fragment>
        <div className="select-city__button">
          { this.renderModalControl() }
        </div>

        { this.renderModal() }
      </Fragment>
    );
  }
}

SelectCity.propTypes = {
  domains: PropTypes.object.isRequired,
  regionNameRu: PropTypes.string,
};

SelectCity.defaultProps = {
  domains: new List(),
  regionNameRu: null,
};

function mapStateToProps (state) {
  return {
    domains: state.getIn(['home', 'domains', 'data']),
    regionNameRu: state.getIn(['domain', 'cityName']),
  };
}

export default connect(mapStateToProps)(SelectCity);



// WEBPACK FOOTER //
// ./src/ui/SelectCity/SelectCity.jsx